module.exports = __webpack_public_path__ + "img/window-flip.330fde86.svg";